import React, { Component } from 'react';
import Footer from './components/Footer';
import TopBar from './components/TopBar';
import { NotificationProvider } from '../state/notifications/NotificationContext';
import { withRouter } from './navigation/withNavigation';
import ProjectsSection from './home/Projects';
import AdminPanel from './admin/AdminPanel';
import { getEffectiveRole } from '../utils';

class Home extends Component {
  render() {
    const { navigate, focusProjectId, onSelect } = this.props;
    const effectiveRole = getEffectiveRole();

    if (effectiveRole === 'admin') {
      return <AdminPanel />;
    }

    return (
      <NotificationProvider>
        <div className="home-page">
          <TopBar />

          <main className="home-main">
            <ProjectsSection
              navigate={navigate}
              focusProjectId={focusProjectId}
              onSelect={onSelect}
            />
          </main>

          <Footer />
        </div>
      </NotificationProvider>
    );
  }
}

export default withRouter(Home);
